// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "yp_user_static/css/" + chunkId + "." + {"67":"48e2df02","114":"d548c230","385":"d25d698e","490":"6134194f","594":"4d9e5280","625":"4f034e44","795":"a1618e0d"}[chunkId] + ".css";
};